<app-base-modal
  [title]="'Видео'"
>
  <div class="container">
    @if (url) {
      <video
        controls
        class="video"
      >
        <source
          [src]="url"
          type="video/mp4"
        >
      </video>
    } @else {
      <div class="skeleton-loader video">
        <div>Загрузка...</div>
        <app-telegram-upload-status
          [useGridLayout]="false"
        />
      </div>
    }
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      [disabled]="isLoading"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
